import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import faveService from "./faveService";

const initialState = {
    faves: [],
    faveReads: [],
    faveWatches: [],
    faveLearns: [],

    favesIsError: false,
    favesIsSuccess: false,
    favesIsPending: false,

    postFaveIsPending: false,
    postFaveIsSuccess: false,
    postFaveIsError: false,

    faveWatchIsPending: false,
    faveWatchIsSuccess: false,
    faveWatchIsError: false,

    favesMessage: ""
}



export const getAllFaves = createAsyncThunk(`Get the faves`, async (_, thunkAPI) => {

        try {

            const id = thunkAPI.getState().auth.user.id
            // console.log("faveslice reporting an id of:", id)
            // const email = thunkAPI.getState().auth.user.email

            return await faveService.getAllFaves(id)
        } catch (error) {
            const favesMessage =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString()
            return thunkAPI.rejectWithValue(favesMessage)
        }
    }
)

export const postFave = createAsyncThunk(`Post a favourite to the user object`, async (mediaData, thunkAPI) => {
        try {
            const id = thunkAPI.getState().auth.user.id
            return await faveService.postFave(id, mediaData)
        } catch (error) {
            const favesMessage =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString()
            return thunkAPI.rejectWithValue(favesMessage)
        }
    }
)

export const postFaveWatch = createAsyncThunk(`Post a favourite Watch to the user object`, async (mediaData, thunkAPI) => {
        try {
            const id = thunkAPI.getState().auth.user.id
            return await faveService.postFave(id, mediaData)
        } catch (error) {
            const favesMessage =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString()
            return thunkAPI.rejectWithValue(favesMessage)
        }
    }
)

export const postFaveRead = createAsyncThunk(`Post a favourite Read to the user object`, async (mediaData, thunkAPI) => {
        try {
            const id = thunkAPI.getState().auth.user.id
            return await faveService.postFave(id, mediaData)
        } catch (error) {
            const favesMessage =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString()
            return thunkAPI.rejectWithValue(favesMessage)
        }
    }
)

export const postFaveLearn = createAsyncThunk(`Post a favourite Learn to the user object`, async (mediaData, thunkAPI) => {
        try {
            const id = thunkAPI.getState().auth.user.id
            return await faveService.postFave(id, mediaData)
        } catch (error) {
            const favesMessage =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString()
            return thunkAPI.rejectWithValue(favesMessage)
        }
    }
)



export const faveSlice = createSlice({
    name: "fave",
    initialState,
    reducers:{
        faveReset: (state) => initialState
    },
    extraReducers: (builder) =>{
        builder
            .addCase(getAllFaves.pending, (state) =>{
                state.favesIsPending = true;
            })
            .addCase(getAllFaves.fulfilled, (state, action) =>{
                state.favesIsPending = false;
                state.favesIsSuccess = true;
                state.faves = action.payload;
                state.faveWatches = action.payload.videos && Object.values(action.payload.videos);
                state.faveReads = action.payload.post && Object.values(action.payload.post);
                state.faveLearns = action.payload.tutorials && Object.values(action.payload.tutorials);
            })
            .addCase(getAllFaves.rejected, (state, action) =>{
                state.favesIsPending = false;
                state.favesIsSuccess = false;
                state.favesIsError = true;
                state.message = action.payload
            })
            .addCase(postFave.pending, (state) => {
                state.postFaveIsPending = true;
            })
            .addCase(postFave.fulfilled, (state ) =>{
                state.postFaveIsPending = false;
                state.postFaveIsSuccess = true;

            })
            .addCase(postFave.rejected, (state, action) =>{
                state.postFaveIsPending = false;
                state.postFaveIsSuccess = false;
                state.postFaveIsError = true;
                state.message = action.payload
            })
            .addCase(postFaveWatch.pending, (state) => {
            state.postFaveWatchIsPending = true;
            })
            .addCase(postFaveWatch.fulfilled, (state, action) =>{
                state.postFaveWatchPending = false;
                state.postFaveWatchSuccess = true;
                state.faveWatches = state.faveWatches && [...state.faveWatches.map(item => item), action.payload]
            })
            .addCase(postFaveWatch.rejected, (state, action) =>{
                state.postFaveWatchIsPending = false;
                state.postFaveWatchIsSuccess = false;
                state.postFaveWatchIsError = true;
                state.message = action.payload
            })
            .addCase(postFaveRead.pending, (state) => {
                state.postFaveReadIsPending = true;
            })
            .addCase(postFaveRead.fulfilled, (state, action) =>{
                state.postFaveReadPending = false;
                state.postFaveReadSuccess = true;
                state.faveReads = state.faveReads && [...state.faveReads.map(item => item), action.payload]

            })
            .addCase(postFaveRead.rejected, (state, action) =>{
                state.postFaveReadIsPending = false;
                state.postFaveReadIsSuccess = false;
                state.postFaveReadIsError = true;
                state.message = action.payload
            })
            .addCase(postFaveLearn.pending, (state) => {
                state.postFaveLearnIsPending = true;
            })
            .addCase(postFaveLearn.fulfilled, (state, action) =>{
                state.postFaveLearnPending = false;
                state.postFaveLearnSuccess = true;
                state.faveLearns = state.faveLearns && [...state.faveLearns.map(item => item), action.payload]

            })
            .addCase(postFaveLearn.rejected, (state, action) =>{
                state.postFaveLearnIsPending = false;
                state.postFaveLearnIsSuccess = false;
                state.postFaveLearnIsError = true;
                state.message = action.payload
            })
    }
})

export const { faveReset } = faveSlice.actions;
export default faveSlice.reducer;
